"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveCarButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var RemoveCarConfirmationModal_1 = require("./RemoveCarConfirmationModal");
var CantRemoveCarAlertModal_1 = require("./CantRemoveCarAlertModal");
var RemoveCarButton = /** @class */ (function (_super) {
    __extends(RemoveCarButton, _super);
    function RemoveCarButton(props) {
        var _this = _super.call(this, props) || this;
        _this.renderModal = _this.renderModal.bind(_this);
        _this.toggleModal = _this.toggleModal.bind(_this);
        _this.state = {
            modalIsOpen: false
        };
        var _a = _this.props, interaction = _a.interaction, vehicleIndex = _a.vehicleIndex;
        var policyHolder = interaction.policyHolder;
        _this.vehicle = interaction.vehicles[vehicleIndex];
        var phIsDriver = _this.vehicle.driverIds.some(function (driverId) { return driverId === policyHolder.personId; });
        _this.isTheOnlyCarWithPhAsDriver = phIsDriver && (policyHolder.numberOfVehicles - 1 < 1);
        return _this;
    }
    RemoveCarButton.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("a", { id: "remove-vehicle-".concat(this.vehicle.registrationNumber), className: "text-blue-2 text-decoration-underline", onClick: this.toggleModal, children: "Remove" }), this.renderModal()] }));
    };
    RemoveCarButton.prototype.renderModal = function () {
        if (this.isTheOnlyCarWithPhAsDriver) {
            var policyHolder = this.props.interaction.policyHolder;
            var reason = "Sorry you can\u2019t remove this car from your quote, ".concat(policyHolder.firstName, " ").concat(policyHolder.lastName, " has to be a named driver on at least one car.");
            return ((0, jsx_runtime_1.jsx)(CantRemoveCarAlertModal_1.CantRemoveCarAlertModal, { reason: reason, isOpen: this.state.modalIsOpen, toggle: this.toggleModal }));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(RemoveCarConfirmationModal_1.RemoveCarConfirmationModal, { vehicle: this.vehicle, vehicleIndex: this.props.vehicleIndex, onConfirm: this.props.onRemove, isOpen: this.state.modalIsOpen, toggle: this.toggleModal }));
        }
    };
    RemoveCarButton.prototype.toggleModal = function () {
        this.setState(function (state) { return ({
            modalIsOpen: !state.modalIsOpen
        }); });
    };
    return RemoveCarButton;
}(React.Component));
exports.RemoveCarButton = RemoveCarButton;
//# sourceMappingURL=RemoveCarButton.js.map